import { Typography } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import { ErrorBoundary } from 'config/sentry';
import { useBackOfficeDeviceCameraSamplePoint } from 'store/modules/backOfficeDevice/hooks';
import { selectRouterQueryStringSelectedDevice } from 'store/modules/routerUtils/selectors';
import SamplePoint from 'types/models/samplePoint';

import CameraDataUsage from '../CameraDataUsage';
import CameraDetails from '../CameraDetails';

export default function BackOfficeDeviceCameraForm() {
  const deviceId = useSelector(selectRouterQueryStringSelectedDevice);
  const cameraSamplePoint = useBackOfficeDeviceCameraSamplePoint(deviceId);

  if (!cameraSamplePoint) return null;
  return (
    <>
      <Typography.Text strong style={{ fontSize: 16 }}>Camera</Typography.Text>

      <ErrorBoundary>
        {/* HACK: The type assertion here can cause potential problems if usage surpasses GetSamplePointDto fields */}
        <CameraDetails isBackOffice samplePoint={cameraSamplePoint as SamplePoint} />
        <br />
        {/* HACK: The type assertion here can cause potential problems if usage surpasses GetSamplePointDto fields */}
        <CameraDataUsage isBackOffice samplePoint={cameraSamplePoint as SamplePoint} />
      </ErrorBoundary>
    </>
  );
}
